export default function containerHasMaterial(container, { materials, category } = {}) {
    return container.materials?.some((material) => {
        if (materials) {
            return materials.split(',').includes(String(material.id));
        }
        if (category) {
            return material.category.id == category;
        }
        return false;
    });
}
